<template>
    <div class="PermissionBox">
        <div class="headerBox">
            <div class="leftBox">
                <el-select v-model="select_module" @change="moduleChage" placeholder="模块筛选" class="handle-select mr10">
                    <el-option v-for="module of modules" :label="module.name" :value="module.packagePath"></el-option>
                </el-select>
            </div>
            <span class="middleBox"></span>
            <div class="rightBox">
                <el-button type="button" @click="resetPermissions">权限重置</el-button>
            </div>
        </div>
        <div class="contentBox">
            <template v-for="item of list" >
                <el-card class="box-card myCard">
                    <div slot="header" class="clearfix">
                        <h4>{{item.permission.permissionName}}</h4>
                    </div>
                    <div v-for="item in item.children" class="text item" style="line-height: 25px;">
                        {{item.permission.permissionName}}
                    </div>
                </el-card>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                select_module:'cn.deacy.shiro',
                modules:'',
                list:[],
            }
        },
        created() {
            this.initModules();
        },
        methods: {
            //初始模块类型筛选select数据
            initModules(){
                this.$axios({
                    method:'get',
                    url:'/api/user/getModules',
                    withCredentials:true,
                    type:'json',
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.modules = response.data.data;
                        this.initPermissions();
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`获取模块列表失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                })
            },
            initPermissions(){
                this.$axios({
                    method:'get',
                    url:'/api/permission/getPermissions',
                    withCredentials:true,
                    type:'json',
                    params:{
                        modulePackage:this.select_module,
                    }
                }).then((response) =>{          //这里使用了ES6的语法
                    if(response.data.code == 1){
                        this.list = response.data.data;
                    }else{
                        this.$message.warning(response.data.message);
                    }
                }).catch((error) =>{
                    this.$message.error(`获取模块列表失败`);
                    console.log(error)       //请求失败返回的数据
                }).finally(()=>{
                })
            },
            moduleChage(){
                this.initPermissions();
            },
            resetPermissions(){
                this.$confirm('此操作将使已分配的"角色-权限"全部失效, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios({
                        method:'get',
                        url:'/api/permission/init',
                        withCredentials:true,
                    }).then((response) =>{          //这里使用了ES6的语法
                        if(response.data.code == 1){
                            this.$message.success("权限重置成功，所有'角色-权限'需重新分配！");
                            this.initModules();
                        }else{
                            this.$message.warning(response.data.message);
                        }
                    }).catch((error) =>{
                        this.$message.error(`权限重置失败`);
                        console.log(error)       //请求失败返回的数据
                    }).finally(()=>{
                    })
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消'
                    });          
                });
            }
        }
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
    .PermissionBox .contentBox{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .PermissionBox .myCard{
        width: 300px;
        height: 300px;
        margin: 10px 0; 
    }
    .PermissionBox .headerBox{
        display: flex;
        flex-direction: row;
    }
    .PermissionBox .headerBox .leftBox{
        width: 200px;
        text-align: left;
    }
    .PermissionBox .headerBox .middleBox{
        flex: 1;
    }
    .PermissionBox .headerBox .rightBox{
        width: 200px;
        text-align: right;
    }
</style>
